var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_33881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.62 5.6675L12.929 5.35854C13.4409 4.84663 14.2708 4.84663 14.7827 5.35854C15.2946 5.87044 15.2946 6.70039 14.7827 7.21229L14.4738 7.52125M12.62 5.6675C12.62 5.6675 12.6586 6.32403 13.2379 6.90333C13.8172 7.48263 14.4738 7.52125 14.4738 7.52125M12.62 5.6675L9.77961 8.50791C9.58722 8.7003 9.49103 8.79649 9.4083 8.90255C9.31071 9.02767 9.22705 9.16305 9.15878 9.30628C9.10091 9.42771 9.05789 9.55677 8.97185 9.81488L8.69639 10.6413L8.60727 10.9086M14.4738 7.52125L11.6334 10.3617C11.441 10.5541 11.3448 10.6502 11.2387 10.733C11.1136 10.8306 10.9782 10.9142 10.835 10.9825C10.7136 11.0404 10.5845 11.0834 10.3264 11.1694L9.5 11.4449L9.23264 11.534M9.23264 11.534L8.96528 11.6231C8.83826 11.6655 8.69822 11.6324 8.60354 11.5377C8.50887 11.4431 8.47581 11.303 8.51815 11.176L8.60727 10.9086M9.23264 11.534L8.60727 10.9086",
    stroke: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 8.97461H7.50065",
    stroke: "#EBF0F3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 6.30859H10.1673",
    stroke: "#EBF0F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 11.6426H6.83398",
    stroke: "#EBF0F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.719 2.42363C12.9379 1.64258 11.6808 1.64258 9.16667 1.64258H7.83333C5.31918 1.64258 4.0621 1.64258 3.28105 2.42363C2.5 3.20468 2.5 4.46175 2.5 6.97591V9.64258C2.5 12.1567 2.5 13.4138 3.28105 14.1949C4.0621 14.9759 5.31918 14.9759 7.83333 14.9759H9.16667C11.6808 14.9759 12.9379 14.9759 13.719 14.1949C14.3477 13.5661 14.4703 12.629 14.4942 10.9759",
    stroke: "#EBF0F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_33881"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.308594,
    width: 16,
    height: 16,
    rx: 5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRequest);
export default __webpack_public_path__ + "static/media/dashboardRequest.51a644cdbf4eb322fcb7fe950449e346.svg";
export { ForwardRef as ReactComponent };